function validateImageURL(url) {
  return new Promise(function (resolve, reject) {
    var image = new Image();
    image.onload = function () {
      var dimensions = {
        width: image.naturalWidth,
        height: image.naturalHeight,
        url: url
      };
      resolve(dimensions);
    };
    image.onerror = image.onabort = reject;
    image.src = url;
  });
}

export { validateImageURL };
//# sourceMappingURL=utils.js.map
